import {ArrowTopRightOnSquareIcon} from '@heroicons/react/24/outline';
import classNames from 'classnames';
import {CSSProperties, useCallback} from 'react';

import Col from '../../../common/Col';
import Row from '../../../common/Row';
import {Link} from '../../types';

type Props = {
  link: Link;
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  hoverDisabled?: boolean;
};
const ArrowIcon = () => <ArrowTopRightOnSquareIcon className="flex-none h-sm w-sm text-primary-600" />;

const LinkButton = (props: Props) => {
  const handleClick = useCallback(() => {
    if (props.onClick) props.onClick();
  }, [props]);
  return (
    <a
      className={classNames(
        'border-normal font-sans rounded-3xl p-xs min-w-[3rem] border-primary-300 text-xl text-primary-600 font-semibold bg-primary-100 no-underline',
        'mobile:text-base',
        !props.hoverDisabled && 'hover:bg-primary-200',
        props.className
      )}
      onClick={handleClick}
      style={props.style}
      target="_blank"
      rel="noreferrer"
      href={props.link.url}
    >
      <Row className="space-x-5 justify-between items-center text-center leading-none">
        <Col className="w-3" />
        <Col className={classNames('grow', !props.link.title && 'break-all')}>{props.link.title || props.link.url}</Col>
        <ArrowIcon />
      </Row>
    </a>
  );
};

export default LinkButton;
